import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { useContext } from "react";
import { InformeFaturamentoContext } from "../../context/InformeFaturamentoContext";
import { ILinhaInformeFaturamentoValidada } from "../../interfaces/ILinhaInformeFaturamento";
import { ButtonSalvar, Header, TextoHeader } from "./style";

const centralizado = (valor: any) => <div className="text-center">{valor ?? "-"}</div>;

export function Resultado() {
  const { linhas, salvar } = useContext(InformeFaturamentoContext);

  const columns: IColum<ILinhaInformeFaturamentoValidada>[] = [
    {
      name: <span>Veículo Cadastrado?</span>,
      selector: ({ veiculoCadastrado }) => centralizado(veiculoCadastrado ? "SIM" : "NÃO"),
      width: "120px",
    },
    {
      name: <span>Já importado Inf Faturamento?</span>,
      selector: ({ jaImportado }) => centralizado(jaImportado ? "SIM" : "NÃO"),
      width: "140px",
    },
    {
      name: <span>Inova</span>,
      selector: ({ inova }) => centralizado(inova),
      width: "90px",
    },
    { name: <span>Alienação</span>, selector: ({ alienacao }) => centralizado(alienacao) },
    { name: <span>Final de Placa</span>, selector: ({ finalPlaca }) => centralizado(finalPlaca) },
    { name: <span>Origem</span>, selector: ({ origem }) => centralizado(origem) },
    { name: <span>Cliente</span>, selector: ({ cliente }) => centralizado(cliente) },
    { name: <span>NF</span>, selector: ({ nf }) => centralizado(nf) },
    { name: <span>Emissão</span>, selector: ({ emissao }) => centralizado(emissao) },
    { name: <span>Chassi</span>, selector: ({ chassi }) => centralizado(chassi) },
    { name: <span>Modelo</span>, selector: ({ modelo }) => centralizado(modelo) },
    { name: <span>Cor</span>, selector: ({ cor }) => centralizado(cor) },
    {
      name: <span>Valor</span>,
      selector: ({ valorExibicao }) => centralizado(`R$ ${valorExibicao ?? "0,00"}`),
    },
    { name: <span>Ano Fab</span>, selector: ({ anoFabricacao }) => centralizado(anoFabricacao) },
    { name: <span>Ano Mod</span>, selector: ({ anoModelo }) => centralizado(anoModelo) },
    { name: <span>Chave</span>, selector: ({ chaveDanfe }) => centralizado(chaveDanfe) },
    { name: <span>UF</span>, selector: ({ uf }) => centralizado(uf) },
    { name: <span>Blindagem</span>, selector: ({ blindagem }) => centralizado(blindagem) },
    { name: <span>Placa Vermelha</span>, selector: ({ placaVermelha }) => centralizado(placaVermelha) },
    { name: <span>Local Lacre</span>, selector: ({ localLacre }) => centralizado(localLacre) },
    {
      name: <span>Telefone Local Emplacamento</span>,
      selector: ({ telefone }) => centralizado(telefone),
    },
  ];

  if (linhas.length === 0) {
    return null;
  }

  return (
    <div className="mt-4 bg-white p-3">
      <Header>
        <TextoHeader>Resultado</TextoHeader>
        <ButtonSalvar variante="primary" type="button" onClick={salvar}>
          Salvar Excel
        </ButtonSalvar>
      </Header>
      <hr />
      <Table
        paginationServer={false}
        columns={columns}
        data={linhas}
        loading={false}
        keyField=""
        pagination
        totalRows={linhas.length}
        rowsPerPage={500}
        paginationRowsPerPageOptions={[100, 200, 500]}
        showHeader={false}
        noSubHeader
      />
    </div>
  );
}
